import { getHashCode } from '@atlaskit/editor-shared-styles/utils';
import { participantColors } from '@atlaskit/editor-shared-styles/constants';
import { getAnonymousAvatarWithStyling } from '@atlaskit/anonymous-assets/get-anonymous-asset';

// IMPORTANT ensure any changes here are also updated in team-presence/useAnonymousAsset
// while this is more suitable to be in a common package (like @atlaskit/editor-common), importing the anonymous-assets package causes
// syntax errors on e2e builds https://atlassian.slack.com/archives/CL6HC337Z/p1750468928674579
export const fetchAnonymousAsset = (presenceId: string | undefined) => {
	const hashCode = presenceId ? getHashCode(presenceId) : 0;

	const primaryIndex = hashCode;
	const secondaryIndex = hashCode % participantColors.length;

	const svgBackgroundColor = participantColors[secondaryIndex].svgBackgroundColor;

	return getAnonymousAvatarWithStyling({
		styleProperties: {
			'background-color': svgBackgroundColor,
		},
		index: primaryIndex,
	});
};
